import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: true,
  relationsList: [],
  contactData: [],
};

const userFormContactSlice = createSlice({
  name: 'userFormContact',
  initialState: initialState,
  reducers: {
    setUserContactForm(state, { payload }) {
      state.isLoading = Object.prototype.hasOwnProperty.call(
        payload,
        'isLoading'
      )
        ? payload.isLoading
        : state.isLoading;
      state.relationsList = Object.prototype.hasOwnProperty.call(
        payload,
        'relationsList'
      )
        ? payload.relationsList
        : state.relationsList;
      state.contactData = Object.prototype.hasOwnProperty.call(
        payload,
        'contactData'
      )
        ? payload.contactData
        : state.contactData;
    },
  },
});

export const { setUserContactForm } = userFormContactSlice.actions;

export const userFormContactReducer = userFormContactSlice.reducer;
